import {
  getDadosCadastrais,
  getGrafo,
  getGrafo2,
  consultarCorreioEletronico,
  consultarDominioEmail,
  consultarEndereco,
  consultarTelefone,
  listarMatches
} from './grupoSocietario'
import { consultarImagens } from './googleMaps'
import { startGenerateDocumento } from './docx'
import { createQueue } from './sqs'
import { startRootStepFunction } from './rootStep'
import { moveComment } from './comments'

const API = {
  comments: {
    move: moveComment
  },
  receitaFederal: {
    matches: {
      consultarCorreioEletronico,
      consultarDominioEmail,
      consultarEndereco,
      consultarTelefone
    }
  },
  googleMaps: {
    consultar: consultarImagens
  },
  docx: {
    startGenerateDocumento
  },
  sqs: {
    create: createQueue
  },
  rootStep: {
    start: startRootStepFunction
  },
  grupoSocietario: {
    getDadosCadastrais,
    getGrafo,
    getGrafo2,
    matches: {
      consultarCorreioEletronico,
      consultarDominioEmail,
      consultarEndereco,
      consultarTelefone,
      listar: listarMatches
    }
  }
}

export default API
